<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="cip">
<p class="crtf"><a class="page" id="piv"></a>The University of Chicago Press, Chicago 60637</p>
<p class="crt">The University of Chicago Press, Ltd., London</p>
<p class="crt">© 2017 by The University of Chicago</p>
<p class="crt">All rights reserved. No part of this book may be used or reproduced in any manner whatsoever without written permission, except in the case of brief quotations in critical articles and reviews. For more information, contact the University of Chicago Press,</p>
<p class="crt">1427 E. 60th St., Chicago, IL 60637.</p>
<p class="crt">Published 2017</p>
<p class="crt">Printed in the United States of America</p>
<p class="crtf">26 25 24 23 22 21 20 19 18 17    1 2 3 4 5</p>
<p class="crtf">ISBN-13: 978-0-226-43544-2 (cloth)</p>
<p class="crt">ISBN-13: 978-0-226-43558-9 (paper)</p>
<p class="crt">ISBN-13: 978-0-226-43561-9 (e-book)</p>
<p class="crt">DOI: 10.7208/chicago/9780226435619.001.0001</p>
<p class="cipf">Library of Congress Cataloging-in-Publication Data</p>
<p class="cipf">Names: Krinsky, John, author. | Simonet, Maud, author.</p>
<p class="cip">Title: Who cleans the park? : public work and urban governance in New York City / John Krinsky and Maud Simonet.</p>
<p class="cip">Description: Chicago ; London : The University of Chicago Press, 2017. | Includes bibliographical references and index.</p>
<p class="cip">Identifiers: LCCN 2016034613 | ISBN 9780226435442 (cloth : alk. paper) | ISBN 9780226435589 (pbk. : alk. paper) | ISBN 9780226435619 (e-book)</p>
<p class="cip">Subjects: LCSH: Parks—New York (State)—New York—Employees. | Parks—Maintenance—New York (State)—New York.</p>
<p class="cip">Classification: LCC SB482.N72 K75 2016 | DDC 333.78/309747—dc23 LC record available at <a class="url" href="https://Iccn.loc.gov/2016034613" target="_blank">https://Iccn.loc.gov/2016034613</a></p>
<p class="crtf"><img alt="" height="12" src="images/infinity-symbol.jpg" width="12"/> This paper meets the requirements of ANSI/NISO Z39.48–1992 (Permanence of Paper).</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-Krinsky-0004.vue?34e5063b